import React, { useState } from 'react'
import { Header, Grid, Modal, Button, Icon, Divider } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";

import "./AccommodationFacilities.css"
// import {Bathtub, Wifi, Parking, Bathtub, TV} from "../../../../assets/icons/Icons"
import {
    Bathtub,
    AirConditioning,
    Balcony,
    Closet,
    CookingBasics,
    Dishes,
    Door,
    Hairdrier,
    Hanger,
    Iron,
    Kitchen,
    Lake,
    Oven,
    Parking,
    Refrigirator,
    Stove,
    TV,
    Washer,
    Wifi,
    Yard
} from "../../../../assets/icons/Icons"

const utilities = {
    Bathroom: {
        Bathtub: true,
        Hairdrier: true
    },
    Bedroom: {
        Closet: true,
        Hanger: true,
        Iron: true,
    },
    Entertainment: {
        TV: true
    },
    HeatingCooling: {
        AirConditioning: true,
        Heating: true,

    },
    Internet: {
        Wifi: true
    },
    Kitchen: {
        CookingBasics: true,
        Oven: true,
        Refrigirator: true,
        Stove: true,
        Washer: true,
        Dishes: true
    },
    Outdoor: {
        Balcony: true,
        Yard: true
    },
    Parking: {
        Parking: true
    }
}
const AccommodationFacilities = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<div id="amenities">
        <Header as='h3'>{t("property:Facilities")}</Header>
        <Grid columns="3">
            <Grid.Column className="d-flex flex-row align-items-center">
                <Bathtub />
                <span className="m-05">{t("property:Bathroom")}</span>
            </Grid.Column>
            <Grid.Column className="d-flex flex-row align-items-center">
                <CookingBasics />
                <span className="m-05">{t("property:CookingBasics")}</span>
            </Grid.Column>
            <Grid.Column className="d-flex flex-row align-items-center">
                <Wifi />
                <span className="m-05">{t("property:Wifi")}</span>
            </Grid.Column>
            <Grid.Column className="d-flex flex-row align-items-center">
                <TV />
                <span className="m-05">{t("property:TV")}</span>
            </Grid.Column>
            <Grid.Column className="d-flex flex-row align-items-center">
                <Yard />
                <span className="m-05">{t("property:Yard")}</span>
            </Grid.Column>
            <Grid.Column className="d-flex flex-row align-items-center">
                <Parking />
                <span className="m-05">{t("property:Parking")}</span>
            </Grid.Column>
        </Grid>

        <Modal
            size="small"
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={<Button size="big" className="m-1-t m-1-b p-1-t p-1-b p-0 bg-transparent text-blue" >{t("property:ShowAllFacilities")}
                <Icon name="chevron right" /></Button>}>
            <Modal.Header>{t("property:AllFacilities")}</Modal.Header>
            <Modal.Content scrolling>
                <Modal.Description>
                    {

                        Object.keys(utilities).map(function (key, index) {
                            return <div key={index}><Header className="m-1-t" as='h3'>{t(`property:Facilities`)} {t(`property:${key}`)}</Header>
                                <Grid>
                                    {
                                        Object.keys(utilities[key]).map(function (childkey, childindex) {
                                            const CustomTag = `${childkey}`
                                            return <Grid.Row key={childindex} className="d-flex flex-row align-items-center p-1 ">
                                                {/* <CustomTag /> */}
                                                <span className="m-05">{t(`property:${childkey}`)}</span>
                                            </Grid.Row>
                                        })

                                    }
                                    <Divider/>
                                </Grid>

                            </div>
                        })

                    }

                </Modal.Description>
            </Modal.Content>
        </Modal>
    </div>
    )
}
export default AccommodationFacilities